import React, { useState } from 'react';

import { 
  BonusSpellsUpgrade
} from "@dndModels";
import StringBox from "@components/input/strings/StringBox";
import Grid from '@mui/material/Grid2';
import SelectStringBox from "@components/input/selects/SelectStringBox";
import { ABILITY_SCORES_EXPANDED } from "@dndModels/Constants";
import { AbilityScoreExpandedType } from "@dndModels/Types";

interface Props {
  obj: BonusSpellsUpgrade;
  onChange: (changed: BonusSpellsUpgrade) => void; 
  disabled: boolean;
}

export default function BonusSpellsUpgradeFeatureInput({ 
  obj,
  onChange,
  disabled
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Upgrade Key"
          value={obj.upgrade_key}
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.upgrade_key = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Spellcasting Ability (When not attached to Class)"
          options={ABILITY_SCORES_EXPANDED}
          value={obj.spellcasting_ability}
          disabled={disabled}
          onChange={(changed: AbilityScoreExpandedType) => {
            const new_obj = obj;
            new_obj.spellcasting_ability = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        { obj.spellcasting_ability === "Selectable" &&
          <StringBox
            name="Spellcasting Ability Key"
            value={obj.spellcasting_ability_key}
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.spellcasting_ability_key = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        }
      </Grid>
    </Grid>
  );
}
